<script setup lang="ts">
import TaskInfoItem from './TaskInfoItem.vue'
import TaskInfoList from './TaskInfoList.vue'
import TaskRelationCustomer from './TaskRelationCustomer.vue'
import TaskRelationRelatedTo from './TaskRelationRelatedTo.vue'

defineOptions({
  name: 'TaskRelations',
})

</script>

<template>
  <TaskInfoList>
    <TaskInfoItem title="Customer">
      <TaskRelationCustomer />
    </TaskInfoItem>
    <TaskInfoItem title="Related to">
      <TaskRelationRelatedTo />
    </TaskInfoItem>
  </TaskInfoList>
</template>
